import React from "react"
import { useState, useEffect } from 'react';

import FormUnit from "../../../elements/Form/FormUnit"
import CheckBox from "../../../elements/Form/CheckBox"
import ShowMore from "./ShowMore";

function naturalSorter(as, bs){
    var a, b, a1, b1, i= 0, n, L,
    rx=/(\.\d+)|(\d+(\.\d+)?)|([^\d.]+)|(\.\D+)|(\.$)/g;
    if(as=== bs) return 0;
    a= as.toLowerCase().match(rx);
    b= bs.toLowerCase().match(rx);
    L= a.length;
    while(i<L){
        if(!b[i]) return 1;
        a1= a[i],
        b1= b[i++];
        if(a1!== b1){
            n= a1-b1;
            if(!isNaN(n)) return n;
            return a1>b1? 1:-1;
        }
    }
    return b[i]? -1:0;
}

const CheckboxFilterBlock = (props) => {
    const [checked, setChecked] = useState(props.options.map(option => option.status));

    const handleChange = (params) => {
        const tmpChecked = { ... checked };
 
        tmpChecked[params.target.name] = !tmpChecked[params.target.name];

        setChecked(tmpChecked);

        const attributeId = params.target.name.split(".")[0];
        let attributeValue = params.target.name.split(".");
        attributeValue.shift();
        attributeValue = attributeValue.join(".");
        const checkStatus = tmpChecked[params.target.name];

        props.onChange({
            id: attributeId,
            value: attributeValue,
            checked: checkStatus
        });
    }

    useEffect(() => {
        if(!props.enabled) {
            return;
        }
        let newChecked = {};

        for(let i in props.options) {
            newChecked[`${props.id}.${props.options[i].key}`] = props.options[i].status;
        }

        setChecked(newChecked);
    }, [props.options]);
    
    return (<>
        {props.options.sort((a, b) => {
            const sortKeyA = a.label.split('$')[0];
            const sortKeyB = b.label.split('$')[0];

            if(props.options.length > 6) {
                if(a.status) return -1;
                if(b.status) return 1;
            }

            if(a.type === 'fixed') {
                return naturalSorter(sortKeyA, sortKeyB) 
            } else if(!isNaN(parseInt(sortKeyA)) && !isNaN(parseInt(sortKeyB))) {
                return a.status !== b.status && a.status === true ? -1 : parseInt(sortKeyA) < parseInt(sortKeyB) ? -1 : 1 
            } else {
                return a.status !== b.status && a.status === true ? -1 : a.count > b.count ? -1 : 1
            }
        }).filter((option, index) => {
            return index < 6 || checked[`${props.id}.${option.key}`] || props.expanded;
        }).map((option, index) => {
            if(props.id === 'availability') {
                option.label = option.label.replace(option.key, {
                    'available': 'Disponibil',
                    'unavailable': 'Indisponibil',
                    'supplier': 'La Comanda',
                    'coming-soon': 'In curand'
                  }[option.key]);
            }
            
            return (
                <FormUnit key={`option-${props.id}-${option.key}-${index}`}>
                    <CheckBox  label={option.label.split("$")[1] || option.label} 
                        field={{onChange: handleChange, disabled: !props.enabled ? true : false, name: `${props.id}.${option.key}`, 
                            checked: checked[`${props.id}.${option.key}`]}} original={true}/>
                </FormUnit>
            )
        })}

        
    </>)
}

export default CheckboxFilterBlock;